module.exports = __webpack_public_path__ + "img/secondary-on.11ca7494.svg";